import { React, ReactRouter, useAPI } from 'mcelroy-lib'
import { FormPage, useToast } from 'mcelroy-components'

/*
    Page to change account password.
*/
export function ChangePasswordPage() {
    const routeParams = ReactRouter.useParams()
    const navigate = ReactRouter.useNavigate()
    const toast = useToast()

    // API user info query
    const { loading, data, error } = useAPI(`
        query($user_id: Int){
            user(id: $user_id){
                id
                email
            }
        }
    `, { user_id: routeParams.user_id })

    // API change password mutation
    const { run: changePassword } = useAPI(`
        mutation($id: Int!, $password: String!){
            changePassword( id:$id, password:$password ){id}
        }
    `)

    const fields = [
        { label: "Email", value: data?.user?.email, name: "email", disabled: true },
        { label: "New Password", value: "", name: "password", type: 'new-password' },
        { label: "New Password Again", value: "", name: "passwordAgain", type: 'new-password' },
    ]

    const buttons = [
        {
            label: 'Save',
            primary: true,
            onClick: async function (formData) {
                try {
                    if (formData.password != formData.passwordAgain) {
                        toast.error('Passwords do not match.')
                        return
                    }
                    await changePassword({ id: routeParams.user_id, password: formData.password })
                    toast.success('Password changed.')
                    navigate('/users/' + routeParams.user_id)
                } catch (err) {
                    toast.error(err[0]?.message ?? 'Error creating account.  Contact support.')
                    console.log(err)
                }
            }
        },
        {
            label: 'Cancel',
            onClick: function () {
                navigate(-1)
            }
        }
    ]

    // Page display
    if (loading)
        return null
    else if (error)
        return (<div>Not authorized</div>)
    else return (
        <div>
            <FormPage pageTitle="Account" title="Change Password" fields={fields} buttons={buttons}>
            </FormPage>
        </div>
    )
}
